import api from './index';

export default {
  // 🔹 Obtener todo el stock
  async getStock(search = '') {
    try {
      const response = await api.get('/stock/', {
        params: { search },
      });
      return response.data; // Devuelve la lista completa
    } catch (error) {
      console.error('Error al obtener el stock:', error);
      throw error;
    }
  },

  // 🔹 Obtener un producto de stock específico
  async getStockById(id: number) {
    try {
      const response = await api.get(`/stock/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener los detalles del stock:', error);
      throw error;
    }
  },

  // 🔹 Actualizar cantidad y mínimo de un producto
  async updateStock(id: number, data: { cantidad?: number; minimo?: number }) {
    try {
      const response = await api.patch(`/stock/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar el stock:', error);
      throw error;
    }
  },
};
